import React from "react";
import PolicyLayout from "../../components/PolicyLayout";
import { Highlight } from "../HomePage";

const TermofUse = () => {
  return (
    <PolicyLayout title={<>Terms Of <Highlight tone="dark">Use</Highlight></>}>
      <p>
        These Terms &amp; Conditions (“Terms”) govern your access to
        and use of the Swasth OPD website (the “Website”) and the
        SaaS-based healthtech infrastructure we provide (the
        “Service”). By accessing or using the Website or Service, you
        agree to be bound by these Terms.
      </p>
      <h2>1. Definitions</h2>
      <div>
        <p>
          <strong>“Swasth OPD”</strong> refers to Swasth OPD
          HealthTech Pvt. Ltd., the provider of the Service.
        </p>
        <p>
          <strong>“You”</strong> refers to the individual or entity
          accessing or using the Website or Service.
        </p>
        <p>
          <strong>“Content”</strong> refers to any information, data,
          text, software, code, or other materials displayed on or
          available through the Website or Service.
        </p>
        <p>
          <strong>“User”</strong> refers to any individual or entity
          who accesses or uses the Website or Service.
        </p>
      </div>
      <h2>2. Use of the Website and Service</h2>
      <div>
        <p>
          You may only use the Website and Service for lawful purposes
          and in accordance with these Terms.
        </p>
        <p>You agree not to use the Website or Service:</p>
        <div style={{ paddingLeft: 10 }}>
          <p>
            • In a manner that could damage, disable, overburden, or
            impair the Website or Service.
          </p>
          <p>
            • To interfere with any other user’s enjoyment of the
            Website or Service.
          </p>
          <p>
            To gain unauthorized access to the Website or Service, or
            any computer systems or networks connected to the Website
            or Service.
          </p>
          <p>
            • To upload, transmit, or store any content that is
            unlawful, harassing, defamatory, obscene, or otherwise
            objectionable.
          </p>
          <p>• To violate any applicable laws or regulations.</p>
        </div>
      </div>
      <h2>3. User Content</h2>
      <div>
        <p>
          You are solely responsible for any content you upload,
          transmit, or store on the Website or Service.
        </p>
        <p>
          You grant Swasth OPD&nbsp; Technologies a non-exclusive,
          royalty-free license to use, reproduce, modify, publish, and
          distribute your User Content in connection with the Website
          and Service.
        </p>
      </div>
      <h2>4. Intellectual Property</h2>
      <div>
        <p>
          The Website and Service, including all Content, are
          protected by copyright, trademark, and other intellectual
          property laws.
        </p>
        <p>
          You agree not to remove, alter, or obscure any copyright
          notices or other proprietary notices placed on the Website
          or Service.
        </p>
      </div>
      <h2>5. Disclaimers</h2>
      <div>
        <p>
          THE WEBSITE AND SERVICE ARE PROVIDED “AS IS” AND WITHOUT
          WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED. Swasth
          OPD DISCLAIMS ALL WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
          THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR
          PURPOSE, AND NON-INFRINGEMENT.
        </p>
        <p>
          Swasth OPD DOES NOT WARRANT THAT THE WEBSITE OR SERVICE WILL
          BE UNINTERRUPTED OR ERROR-FREE, THAT DEFECTS WILL BE
          CORRECTED, OR THAT THE WEBSITE OR SERVICE IS FREE OF VIRUSES
          OR OTHER HARMFUL COMPONENTS.
        </p>
      </div>
      <h2>6. Limitation of Liability</h2>
      <div>
        <p>
          Swasth OPD SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT,
          INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES
          ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE WEBSITE
          OR SERVICE.
        </p>
      </div>
      <h2>7. Term and Termination</h2>
      <div>
        <p>
          These Terms shall remain in full force and effect until
          terminated by you or Swasth OPD.
        </p>
        <p>
          Swasth OPD may terminate these Terms at any time, with or
          without cause, upon written notice to you.
        </p>
        <p>
          You may terminate these Terms by discontinuing your use of
          the Website and Service.
        </p>
      </div>
      <h2>8. Governing Law</h2>
      <div>
        <p>
          These Terms shall be governed by and construed in accordance
          with the laws of India.
        </p>
      </div>
      <h2>9. Entire Agreement</h2>
      <div>
        <p>
          These Terms constitute the entire agreement between you and
          Swasth OPD with respect to the use of the Website and
          Service.
        </p>
      </div>
      <h2>10. Severability</h2>
      <div>
        <p>
          If any provision of these Terms is held to be invalid or
          unenforceable, such provision shall be struck and the
          remaining provisions shall remain in full force and effect.
        </p>
      </div>
      <h2>11. Waiver</h2>
      <div>
        <p>
          No waiver of any provision of these Terms shall be deemed a
          further or continuing waiver of such provision or any other
          provision.
        </p>
      </div>
      <h2>12. Update to Terms</h2>
      <div>
        <p>
          Swasth OPD may update these Terms at any time by posting the
          amended terms on the Website. Your continued use of the
          Website or Service following the posting of amended Terms
          constitutes your acceptance of the amended Terms.
        </p>
      </div>
      <h2>13. Contact Us</h2>
      <p>
        If you have any questions about these Terms, please contact us
        at contact@swasthopd.com
      </p>
      <h2>14. LEGAL DISCLAIMER</h2>
      <p>
        By engaging in a transaction with the Company, all customers
        acknowledge and agree to the below mentioned terms. Any
        violation of the below terms may result in legal consequences
        as per the applicable laws.
      </p>
      <ul style={{ paddingLeft: 20 }}>
        <li>
          1.{" "}
          <strong>No Unauthorized Inducements or Commitments</strong>{" "}
          <br />
          No person shall, directly or indirectly, offer or induce any
          other person to engage in a transaction under false
          pretences. The Company does not assume responsibility for
          any false commitments or inducements made by its agents or
          telemarketing representatives in relation to the sale of any
          product. In case of any doubt regarding the authenticity of
          any commitment or representation, the same may be verified
          through a confirmation call conducted by the Company before
          any payment is made. Customers also have the right to verify
          within fifteen (15) days of making a payment by contacting
          our customer service at 1800 309 2740 or via email at
          hello@swasthopd.com. No agreement shall be challenged on any
          grounds after the expiration of fifteen (15) days from the
          date of issuance or from the commencement of risk coverage.
        </li>
        <li>
          2. <strong>Third-Party Payments</strong> <br />
          The Company shall not be held responsible for payments made
          by the customer to any third parties / any payment made by
          third party on behalf of the customer. If a customer makes a
          payment to any third party under any influence or coercion,
          the responsibility lies solely with the customer. The
          Company disclaims all liability in such circumstances. The
          Company does not accept cash payments for any transactions.
          Customers are advised to refrain from making cash
          transactions under any circumstances, as the Company will
          not be held accountable for such payments.
        </li>
        <li>
          3. <strong>Disclaimer* </strong> The Company shall not be held responsible for payments made by the customer to any third parties / any payment made by third party on behalf of the customer. HospiCash, Accidental Insurance or any cover is not available at age above 60 years.
        </li>
      </ul>
    </PolicyLayout>
  );
};

export default TermofUse;
